import { SVGProps } from 'react';
import sprite from 'core/common/assets/images/sprites/sprite.svg';
import { IconNameOrString } from 'core/svg-sprites/entities';
import { IconStyled } from './styled';

export type IconProps = {
  name: IconNameOrString;
  className?: string;
} & Omit<SVGProps<SVGSVGElement>, 'name' | 'ref'>;

export const Icon = ({ name, className = '', ...rest }: IconProps) => {
  return (
    <IconStyled
      {...rest}
      width={rest.width ?? '16px'}
      height={rest.height ?? '16px'}
      className={className}
    >
      <use xlinkHref={`${sprite}#${name}`} />
    </IconStyled>
  );
};
